module.exports = __webpack_public_path__ + "img/softinya-teaser.a88da187.png";